enum Feature {
  'Navbar.Management' = 'Navbar.Management',
  'Route.Management' = 'Route.Management',
  'Navbar.Management.PriceList' = 'Navbar.Management.PriceList',
  'Route.Management.PriceList' = 'Route.Management.PriceList',
  'Navbar.Management.Layout' = 'Navbar.Management.Layout',
  'Route.Management.Layout' = 'Route.Management.Layout',
  'Navbar.Management.Events' = 'Navbar.Management.Events',
  'Route.Management.Events' = 'Route.Management.Events',
  'Navbar.Terminals' = 'Navbar.Terminals',
  'Route.Terminals' = 'Route.Terminals',
  'Navbar.Terminals.Settings' = 'Navbar.Terminals.Settings',
  'Route.Terminals.Settings' = 'Route.Terminals.Settings',
}

export { Feature }
